import { connect } from 'react-redux';
import { callSelectors, networkSelectors } from '@lifesize/nucleus';
import NotificationLostConnection from 'components/NotificationLostConnection/NotificationLostConnection';
import { isDroppedCall, isCallConnected } from '../../utils/call-utils';
import { isReconnecting as isReconnectingSelector } from 'selectors/connection';

const mapActionCreators = () => ({
});

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const isCallDropped = isDroppedCall(activeCall);
  const isCallActive = isCallConnected(activeCall);
  const isOffline = networkSelectors.isOffline(state);
  return {
    isReconnecting: isReconnectingSelector(state),
    isCallDropped,
    isOffline,
    isCallActive
  };
};

export default connect(mapStateToProps, mapActionCreators)(NotificationLostConnection);
